/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { booleanToString } from "abreact/data/AbBooleanRenderer";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { AbEnriched } from "abreact/utils/enrichment/AbEnriched";
import { AbKeySet } from "abweb/collection/AbKeySet";
import { AbSet } from "abweb/collection/AbSet";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { TypeUtils } from "abweb/utils/TypeUtils";
import * as React from "react";
export const AbInputLabel = (label, id, tooltip, style) => {
  return /*#__PURE__*/React.createElement(AbWithTooltip, {
    tooltip: tooltip
  }, /*#__PURE__*/React.createElement("span", {
    className: "ab-input-label",
    style: style
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label)));
};

/**
 * The type of a function that can return a label for an item.
 */

/**
 * A simple function to return a label for an item.
 */
export function defaultItemDisplayStringFunction(value) {
  if (typeof value === "boolean") return booleanToString(value);
  if (TypeUtils.isPrimitive(value) || value == null) {
    return value?.toLocaleString() ?? "";
  } else if (AbEnriched.isEnriched(value)) {
    const enrichment = AbEnriched.getEnrichment(value);
    if (enrichment && enrichment.displayName) {
      return enrichment.displayName;
    }
    return defaultItemDisplayStringFunction(AbEnriched.getItem(value));
  } else if (ClassUtils.isInstanceOf(value, Set) || ClassUtils.isInstanceOf(value, AbSet) || ClassUtils.isInstanceOf(value, AbKeySet)) {
    return `{${Array.from(value).map(defaultItemDisplayStringFunction).join(", ")}}`;
  } else if (ClassUtils.isInstanceOf(value, Array)) {
    return `[${value.map(defaultItemDisplayStringFunction).join(", ")}]`;
  }
  return value.toLocaleString();
}
//# sourceMappingURL=AbInputUtils.js.map
